import { gql } from '@apollo/client';

export const createCategory = gql`
  mutation createCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      id
      name {
        languageCode
        value
      }
      ordinal
      expand
      description {
        languageCode
        value
      }
    }
  }
`;

export const updateCategory = gql`
  mutation updateCategory($input: UpdateCategoryInput!) {
    updateCategory(input: $input) {
      id
      name {
        languageCode
        value
      }
      ordinal
      expand
      description {
        languageCode
        value
      }
      courses {
        id
        shortId
        name {
          languageCode
          value
        }
      }
      catalogs {
        id
        name {
          languageCode
          value
        }
      }
    }
  }
`;

export const deleteCategory = gql`
  mutation deleteCategory($id: ID!) {
    deleteCategory(id: $id) {
      id
    }
  }
`;
